// config/contact.ts
// Configurazione centralizzata per email e telefono di contatto

export const CONTACT_INFO = {
  email: 'support@escortfun.net',
  phone: '+385 98 190 7843',
  phoneHref: '+385981907843', // versione senza spazi per href
};
